import React from 'react'
import './PropertyImage.scss'
import PropTypes from 'prop-types'
import Comps from '@engine/comps'
import { connect } from 'react-redux'
import { SALES_COMPARABLES } from '@engine/dependencies/constants'

export class PropertyImage extends React.Component {

  render() {
    const { propertyType, imageUrl, templateName, themeColors } = this.props
    const markerStyle = propertyType.toString().includes('S') ? {
      color: themeColors.subjectMarkerTextColor,
      backgroundColor: themeColors.subjectMarkerBackgroundColor,
      border: `1px solid ${themeColors.subjectMarkerBorderColor}`
    } : {
      color: themeColors.comparableMarkerTextColor,
      border: `1px solid ${themeColors.comparableMarkerBorderColor}`,
      backgroundColor: themeColors.comparableMarkerBackgroundColor
    }

    return (
      <div className={templateName.includes(SALES_COMPARABLES) ? 'property-img-sales' : 'property-img'}>
        <div data-testid="property-img" className={`property-img__label property-img__label_${propertyType} `} style={markerStyle}>{propertyType}</div>
        <div className={imageUrl === '' ? 'nophoto' : 'prop-img-block'}>
          {imageUrl === '' ? <div className="nophoto">No photo</div> : <img
            className="img-style"
            src={
              imageUrl
            }
          />}

        </div>
      </div>
    )
  }
}

PropertyImage.propTypes = {
  propertyType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  imageUrl: PropTypes.string,
  templateName: PropTypes.string,
  themeColors: PropTypes.object
}

const mapStateToProps = state => ({
  themeColors: Comps.selectors.comps.themeColors(state)
})

export default connect(mapStateToProps)(PropertyImage)
